export enum UpsellResultEnum {
  ACCEPTED = 'accepted',
  DECLINED = 'declined',
  PLANS_REDIRECT = 'plans_redirect',
  SKIPPED = 'skipped',
  UNAVAILABLE = 'unavailable',
  ERROR = 'error',
}
